import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import { EFMail, EFPhone } from '@/components/UI/svg/Support';

export default function SupportContactUs({ isShow = false, nodata = false }: any) {
    const { useLang, useRouter } = useGlobal();
    const { t } = useLang('shared');
    const { locale } = useRouter();
    const emailMap = {
        us: 'mailto:support@ecoflow.com',
        uk: 'mailto:support.eu@ecoflow.com',
        au: 'mailto:support.au@ecoflow.com',
        jp: 'mailto:support.jp@ecoflow.com',
    } as any;

    const telMap = {
        us: '+1(800)-368-8604',
        jp: '+81(050)-3090-2966',
        cn: '400-600-5753',
        za: '+27(080)-088-0002',
    } as any;

    const onQuiry = () => {
        if (locale === 'jp') {
            window.open('https://jp.ecoflow.com/pages/contactus', '_blank');
        }
    };

    return (
        <div className={`${css.supportContactH5} supportContactH5 ${nodata ? 'nodata' : ''}`}>
            {isShow && (
                <div>
                    <h2 className="title-spac font-family-bold" onClick={onQuiry}>
                        {t('support.site_support_contact_us')}
                    </h2>
                    <div className="contact-list">
                        <ul>
                            {locale !== 'cn' && (
                                <li>
                                    <a href={emailMap[locale] || emailMap.us} aria-label={t('support.site_support_mail_us')}>
                                        <div className="contactus_icons">
                                            <EFMail />
                                        </div>
                                        <p className="text-us">{t('support.site_support_mail_us')}</p>
                                    </a>
                                </li>
                            )}
                            {telMap[locale] && (
                                <li>
                                    <a href={`tel:${telMap[locale]}`} aria-label={t('support.site_support_call_us')}>
                                        <div className="contactus_icons">
                                            <EFPhone />
                                        </div>
                                        <p className="text-us">{t('support.site_support_call_us')}</p>
                                        {locale === 'cn' && <p className="telNum">{telMap[locale]}</p>}
                                        {locale === 'jp' && <p className="telNum">{t('support.site_support_tel_note')}</p>}
                                    </a>
                                </li>
                            )}
                        </ul>
                    </div>
                </div>
            )}
        </div>
    );
}
